import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    removeExercicioConsultaCreditoOrcamentarioReceitasProprias: [],
    removeAdministracaoConsultaCreditoOrcamentarioReceitasProprias: [],
    removeRecursoConsultaCreditoOrcamentarioReceitasProprias: [],
    removeDestinacaoConsultaCreditoOrcamentarioReceitasProprias: [],
    removeMoedaConsultaCreditoOrcamentarioReceitasProprias: [],
    removeGrauConsultaCreditoOrcamentarioReceitasProprias: [],
    setMostraAplicarFiltroConsultaCreditoOrcamentarioReceitasProprias: [],
    limpaFiltroConsultaCreditoOrcamentarioReceitasProprias: [],
    aplicarFiltroConsultaCreditoOrcamentarioReceitasProprias: ['filtro'],
})

const INITIAL_STATE = {
    exercicio: { value: new Date().getFullYear(), label: new Date().getFullYear() },
    administracao: [],
    recurso: [],
    destinacao: [],
    moeda: [],
    grau: '',
    mostraAplicarFiltro: false,
    status: '',
}

const removeExercicio = (state = INITIAL_STATE, action) => {
    return { ...state, exercicio: '', mostraAplicarFiltro: true }
}

const removeAdministracao = (state = INITIAL_STATE, action) => {
    state.administracao.splice(state.administracao.indexOf(action.administracao), 1)
    state.administracao = Array.from(state.administracao)
    return { ...state, mostraAplicarFiltro: true }
}

const removeRecurso = (state = INITIAL_STATE, action) => {
    state.recurso.splice(state.recurso.indexOf(action.recurso), 1)
    state.recurso = Array.from(state.recurso)
    return { ...state, mostraAplicarFiltro: true }
}

const removeDestinacao = (state = INITIAL_STATE, action) => {
    state.destinacao.splice(state.destinacao.indexOf(action.destinacao), 1)
    state.destinacao = Array.from(state.destinacao)
    return { ...state, mostraAplicarFiltro: true }
}

const removeMoeda = (state = INITIAL_STATE, action) => {
    state.moeda.splice(state.moeda.indexOf(action.moeda), 1)
    state.moeda = Array.from(state.moeda)
    return { ...state, mostraAplicarFiltro: true }
}

const removeGrau = (state = INITIAL_STATE, action) => {
    return { ...state, grau: '', mostraAplicarFiltro: true }
}

const setMostraAplicarFiltro = (state = INITIAL_STATE, action) => {
    return { ...state, mostraAplicarFiltro: !state.mostraAplicarFiltro }
}

const aplicarFiltro = (state = INITIAL_STATE, action) => {
    action.filtro.mostraAplicarFiltro = false
    return action.filtro
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.REMOVE_EXERCICIO_CONSULTA_CREDITO_ORCAMENTARIO_RECEITAS_PROPRIAS]: removeExercicio,
    [Types.REMOVE_ADMINISTRACAO_CONSULTA_CREDITO_ORCAMENTARIO_RECEITAS_PROPRIAS]: removeAdministracao,
    [Types.REMOVE_RECURSO_CONSULTA_CREDITO_ORCAMENTARIO_RECEITAS_PROPRIAS]: removeRecurso,
    [Types.REMOVE_DESTINACAO_CONSULTA_CREDITO_ORCAMENTARIO_RECEITAS_PROPRIAS]: removeDestinacao,
    [Types.REMOVE_MOEDA_CONSULTA_CREDITO_ORCAMENTARIO_RECEITAS_PROPRIAS]: removeMoeda,
    [Types.REMOVE_GRAU_CONSULTA_CREDITO_ORCAMENTARIO_RECEITAS_PROPRIAS]: removeGrau,
    [Types.SET_MOSTRA_APLICAR_FILTRO_CONSULTA_CREDITO_ORCAMENTARIO_RECEITAS_PROPRIAS]: setMostraAplicarFiltro,
    [Types.LIMPA_FILTRO_CONSULTA_CREDITO_ORCAMENTARIO_RECEITAS_PROPRIAS]: limpaFiltro,
    [Types.APLICAR_FILTRO_CONSULTA_CREDITO_ORCAMENTARIO_RECEITAS_PROPRIAS]: aplicarFiltro,
})
